export const NON_EMPTY_TAGS = ["img", "iframe"];

export const MARGIN_HEIGHT = 8;

export const EMPTY_TAGS_TO_REMOVE = [
  "p",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "br",
];

export const DEFAULT_SEARCH_KEYS = [
  { name: "title", weight: 0.7 },
  { name: "optionName", weight: 0.6 },
  { name: "description", weight: 0.1 },
];

export const FUZZY_SEARCH_DEFAULT_LIMIT = 4;
